module.exports = __webpack_public_path__ + "img/portrait-004.2588c52b.jpg";